import { Radio } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Price from './Price';
import SalesBorderWrapper from './SalesBorderWrapper';
import type { SaleEventProps } from './useSaleEvent';
import YearlyDiscountChip from './YearlyDiscountChip';

interface PricingCardOptionProps {
  label: string;
  price: string;
  oldPrice: string;
  selected: boolean;
  setSelectedOption: (type: string) => void;
  billingCycle: 'monthly' | 'yearly';
  matchingSaleEvent?: SaleEventProps;
  cardType: 'pro' | 'universe';
}

interface StyleProps {
  selected?: boolean;
  additional?: any;
}

const useStyles = makeStyles<StyleProps>()((_theme, props) => ({
  oldPrice: {
    fontSize: 12,
    textDecoration: 'line-through',
  },
  priceContainer: {
    display: props.selected ? 'grid' : 'flex',
    gridTemplateColumns: props.selected ? '1.6fr 1fr' : undefined,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'start',
  },
  price: {
    textAlign: 'right',
    fontSize: 12,
  },
  label: {
    cursor: 'pointer',
  },
  saleBorderText: {
    position: 'absolute',
    top: -11,
    right: 10,
    padding: '0 5px',
    background: '#252526',
    ...props.additional?.radioBorderText,
  },
}));

const PricingCardOption: React.FC<PricingCardOptionProps> = ({
  label,
  price,
  oldPrice,
  selected,
  setSelectedOption,
  billingCycle,
  matchingSaleEvent,
  cardType,
}) => {
  const { classes } = useStyles({ selected, additional: matchingSaleEvent?.styles });
  const { t } = useTranslation();

  return (
    <SalesBorderWrapper
      selected={selected}
      matchingSaleEvent={matchingSaleEvent}
      withRadioSelection
    >
      {matchingSaleEvent && selected && (
        <div className={classes.saleBorderText}>{matchingSaleEvent.borderText}</div>
      )}
      <Radio
        id={`btn_pricing_${cardType}_${billingCycle}`}
        size="small"
        style={{ padding: 8 }}
        checked={selected}
        onChange={() => setSelectedOption(billingCycle)}
      />

      <div className={classes.priceContainer}>
        <div>
          <label className={classes.label} htmlFor={`btn_pricing_${cardType}_${billingCycle}`}>
            {label}
            {!selected && (
              <>
                <br />
                {oldPrice && <span className={classes.oldPrice}>{oldPrice}</span>}
                <span className={classes.price}>
                  {'  '}
                  {price}
                  {t('home.pricing.month')}
                </span>
              </>
            )}
          </label>

          {billingCycle === 'yearly' && <YearlyDiscountChip />}
        </div>
        {selected && (
          <Price
            matchingSaleEvent={matchingSaleEvent}
            withRadioSelection
            price={price}
            oldPrice={oldPrice}
            billingCycle={billingCycle}
          />
        )}
      </div>
    </SalesBorderWrapper>
  );
};

export default PricingCardOption;
